import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_SERVICE_DATA = 'SET_SERVICE_DATA';
export const BULK_SET_SERVICES_DATA = 'BULK_SET_SERVICES_DATA';
export const SET_SERVICE_ACTIONS = 'SET_SERVICE_ACTIONS';
export const SET_SERVICE_SEARCH_OR_CREATE_ACTIONS = 'SET_SERVICE_SEARCH_OR_CREATE_ACTIONS';
export const SET_ACTIVE_FETCH = 'SET_ACTIVE_FETCH';
export const SET_SERVICE_ACTION_COLLECTION_DATA = 'SET_SERVICE_ACTION_COLLECTION_DATA';
export const BULK_SET_SERVICE_ACTION_COLLECTIONS_DATA = 'BULK_SET_SERVICE_ACTION_COLLECTIONS_DATA';
export const SET_LOADED_STATE_FOR_SERVICE_ACTION_COLLECTION = 'SET_LOADED_STATE_FOR_SERVICE_ACTION_COLLECTION';
export const SET_DIRECTORY_APPS = 'SET_DIRECTORY_APPS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_SERVICE_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.data, key, value);
	},
	[BULK_SET_SERVICES_DATA](state, { data }) {
		Vue.set(state, 'data', { ...state.data, ...data });
	},
	[SET_SERVICE_ACTIONS](state, payload) {
		const { id, version, data } = payload;

		// Legacy, before service versions
		Vue.set(state.servicesActionsIds, id, data);

		// Per service version
		Vue.set(state.actionIdsByVersion, id, { ...(state.actionIdsByVersion[id] || {}), [version]: data });
	},
	[SET_SERVICE_SEARCH_OR_CREATE_ACTIONS](state, payload) {
		const { id, version, data } = payload;

		// Legacy, before service versions
		Vue.set(state.servicesSearchOrCreatesActionsIds, id, data);

		// Per service version
		Vue.set(state.searchCreateIdsByVersion, id, { ...(state.searchCreateIdsByVersion[id] || {}), [version]: data });
	},
	[SET_ACTIVE_FETCH](state, payload) {
		const { key, value } = payload;
		Vue.set(state.activeAppActionsFetches, key, value);
	},
	[SET_SERVICE_ACTION_COLLECTION_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.collectionActionsData, key, value);
	},
	[BULK_SET_SERVICE_ACTION_COLLECTIONS_DATA](state, { data }) {
		Vue.set(state, 'collectionActionsData', { ...state.collectionActionsData, ...data });
	},
	[SET_LOADED_STATE_FOR_SERVICE_ACTION_COLLECTION](state, payload) {
		const { key, value } = payload;
		Vue.set(state.actionsLoadedForCollectionsMap, key, value);
	},
	[SET_DIRECTORY_APPS](state, directoryApps) {
		Vue.set(state, 'directoryApps', directoryApps);
	},
};

export default mutations;
